import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import NotFound from '../../app/layout/NotFound';
import { RootStoreContext } from '../../app/stores/rootStore';

interface IProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>>;
}

const LunaSeaAuthCompleteRoute: React.FC<IProps> = ({ component: Component, ...rest }) => {
  const rootStore = useContext(RootStoreContext);
  const { isLogInLunaSeaAuth } = rootStore.memberStore;
  return <Route {...rest} render={(props) => (isLogInLunaSeaAuth ? <Component {...props} /> : <NotFound />)} />;
};

export default observer(LunaSeaAuthCompleteRoute);
